import moment from 'moment';
import { config, IJsonRpcResponse } from "./api";

interface INote {
    id: number,
    content: string,
    userProfileID: number,
}

export interface ITerminationRequest {
    id: number,
    companyProfileID: number,
    customerID: number,
    userProfileID: number,
    requestDate: string,
    requestDateMoment: moment.Moment | null,
    terminationDate: string,
    terminationDateMoment: moment.Moment | null,
    isProcessed: boolean,
    note: INote,
    companyInfo: ICompanyInfo | null,
}

export interface IAttritionByRequest {
    id: number,
    companyName: string,
    serviceEndDate: string,
    isActive: boolean,
    isReseller: boolean,
    monitorBilling: boolean,
    isCountryPartnerAccount: boolean,
    productOffering: number,
    flags: number,
    terminationRequest: ITerminationRequest,
}

export interface IAttritionByDefault {
    id: number,
    companyName: string,
    serviceEndDate: string,
    isActive: boolean,
    isReseller: boolean,
    monitorBilling: boolean,
    isCountryPartnerAccount: boolean,
    productOffering: number,
    flags: number,
}

interface ICompanyInfo {
    id: number,
    companyName: string,
    clusterID: number,
    createTimestamp: string,
}

interface IGetTerminationReportResponse extends IJsonRpcResponse {
    result: {
        report: {
            attritionsByRequest: IAttritionByRequest[]
            attritionsByDefault: IAttritionByDefault[]
            terminateInMonth: ITerminationRequest[],
            requestedInMonth: ITerminationRequest[],
        }
    }
}
interface IGetTerminationRequestResponse extends IJsonRpcResponse {
    result: {
        terminationRequest: ITerminationRequest,
    },
}

interface ISetTerminationRequestResponse extends IJsonRpcResponse {
    result: {
        terminationRequestID: number,
    },
}

export const getTerminationRequest = async (terminationRequestID: number) => {
  const data = {
      'terminationRequestID': terminationRequestID,
  };
  const res = await fetch(`${config.url}/getTerminationRequest`, {
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + config.authToken,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  const body: IGetTerminationRequestResponse = await res.json();
  return body.result.terminationRequest;
}

export const setTerminationRequest = async (
    companyID: number,
    terminationRequestID: number | null,
    requestDate: string,
    terminationDate: string,
    note: string,
) => {
    const data = {
        'companyID': companyID,
        'note': note,
        'requestDate': requestDate,
        'terminationDate': terminationDate,
        'terminationRequestID': terminationRequestID
    };
    const res = await fetch(`${config.url}/setTerminationRequest`, {
      body: JSON.stringify(data),
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + config.authToken,
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const body: ISetTerminationRequestResponse = await res.json();
    return body.result.terminationRequestID;
}

export const deleteTerminationRequest = async (terminationRequestID: number) => {
    const data = {'terminationRequestID': terminationRequestID};
    const res = await fetch(`${config.url}/deleteTerminationRequest`, {
        body: JSON.stringify(data),
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + config.authToken,
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });
    return res;
}

export const getTerminationReport = async (month: moment.Moment) => {
    const data = {
        'endDate': month.endOf('month').format('YYYY-MM-DD'),
        'startDate': month.startOf('month').format('YYYY-MM-DD'),
    };

    const res = await fetch(`${config.url}/getTerminationReport`, {
        body: JSON.stringify(data),
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + config.authToken,
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });

    const body: IGetTerminationReportResponse = await res.json();
    return body.result.report;
}
